import type { SerpFailure } from '../../types';

/**
 * "Search failed" beside a keyword whose last search came back with nothing.
 * Without it, a failed fetch just went back to "Fetch SERP" as if nothing had
 * happened. Hidden when a newer search worked or one is running.
 */

interface Row {
  serp_failure?: SerpFailure | null;
  has_pending_serp_request?: boolean;
  latest_serp_date?: string | null;
}

/** Whether the row's last search failed and nothing newer has replaced it. Exported for tests. */
export function failedSince(row: Row): SerpFailure | null {
  const f = row.serp_failure;
  if (!f || row.has_pending_serp_request) return null;
  if (row.latest_serp_date && Date.parse(row.latest_serp_date) >= Date.parse(f.at)) return null;
  return f;
}

export function failureText(f: SerpFailure): string {
  const where = f.engines.length ? ` on ${f.engines.join(' and ')}` : '';
  return `The last search${where} failed: ${f.reason}. Fetch again to try another engine.`;
}

export default function SerpFailedNote({ row }: { row: Row }) {
  const f = failedSince(row);
  if (!f) return null;
  return (
    <span className="text-xs text-red-600 dark:text-red-400 cursor-help whitespace-nowrap" title={failureText(f)}>
      Search failed
    </span>
  );
}
